<template>
    
    <!-- Enabled: "bg-blue-500", Not Enabled: "bg-gray-200" -->
    <button type="button" @click.stop="onClick" 
            class="relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-blue-500"
            :class="[value ? 'bg-blue-500' : 'bg-gray-200', size === 'small' ? 'h-5 w-8' : 'h-6 w-11']"
            aria-pressed="true" 
            aria-labelledby="privacy-option-1-label" 
            aria-describedby="privacy-option-1-description">
        <span class="sr-only">Use setting</span>
        <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
        <span aria-hidden="true" 
              class="inline-block rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
              :class="[value ? 'translate-x-5' : 'translate-x-0', size === 'small' ? 'h-4 w-4' : 'h-5 w-5']"
            ></span>
    </button>

</template>
<script>
export default {
    props: {
        value: null,
        size: { default: 'medium' }
    },
    methods: {
        onClick() {
            this.$emit('onChange', !this.value);
        }
    }
}
</script>